import { useEffect, useState } from 'react';

export const useExamNavigationHook = (
  timeLeft: number,
  onFinish: (isTimeExpired?: boolean) => void,
  isPractice: boolean
) => {
  const [time, setTime] = useState(timeLeft);
  const [innerWidth, setInnerWidth] = useState<number>(window.innerWidth);

  // `useState(timeLeft)` só vale na montagem. Com o prazo chegando do servidor
  // depois do primeiro render — ou mudando ao alternar entre os dias — sem esta
  // ressincronização o relógio congela no valor inicial ou dispara o "tempo
  // esgotado" assim que monta com 0.
  useEffect(() => {
    setTime(timeLeft);
  }, [timeLeft]);

  useEffect(() => {
    const handleResize = () => {
      setInnerWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    let timerId: NodeJS.Timeout | undefined;

    if (time > 0) {
      timerId = setInterval(() => {
        setTime((prevTime) => prevTime - 1000);
      }, 1000);
    } else {
      if(!isPractice) {
        onFinish(true);
      }
      
      clearInterval(timerId);
    }

    return () => clearInterval(timerId);
  }, [time, onFinish]);

  let hours, minutes, seconds;

  seconds = Math.floor(time / 1000);
  minutes = Math.floor(seconds / 60);
  seconds = Math.max(0, seconds % 60);
  hours = Math.floor(minutes / 60);
  minutes = Math.max(0, minutes % 60);
  hours = Math.max(0, hours % 24);

  const formattedTime = `${String(hours).padStart(2, '0')}:${String(
    minutes
  ).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

  return {
    innerWidth,
    formattedTime,
  };
};
